export { Section } from "./section";
export type { BackgroundVariant } from "./section";
